const dataIdFromObject = (result)=>{
    var _result_cacheContextKey;
    const cacheContextKey = result && typeof result === 'object' ? (_result_cacheContextKey = result.cacheContextKey) !== null && _result_cacheContextKey !== void 0 ? _result_cacheContextKey : result.cache_context_key : undefined;
    if (result.__typename && cacheContextKey !== undefined && cacheContextKey !== null && cacheContextKey !== '' && result.id !== undefined && result.id !== null && result.id !== '') {
        return `${result.__typename}:${cacheContextKey}:${result.id}`;
    }
    if (result.__typename && result.id !== undefined && result.id !== null && result.id !== '' && // This is a special-case hack in order to handle the fact that source ids
    // are not really unique, i.e. multiple charges can contain sources that
    // share ids, but have different payloads part from id.
    //
    // So we bail out of using source.id for purposes of `dataId` here, which
    // will force apollo-client to fall back to the parent object for cache key
    // purposes.
    //
    // See https://jira.corp.stripe.com/browse/RUN_PAYDASH-2220 and
    // https://confluence.corp.stripe.com/display/AUTH/Card+Ancestry+Tree
    result.__typename !== 'OpenapiSource') {
        return `${result.__typename}:${result.id}`;
    }
    return undefined;
};
export default dataIdFromObject;

//# sourceMappingURL=dataIdFromObject.js.map